/**
 * Quick Jump. Uses value from select field to redirect.
 *
 * <select class="js-quickjump">
 * 	<option value="https://wwww.treco.co.uk">...</option>
 *	</select>
 */

const elements = Array.from(document.querySelectorAll('.js-quickjump'));

elements.forEach(element => element.addEventListener('change', quickJump));

function quickJump(event) {
	const { target } = event;

	if (target.tagName.toLowerCase() !== 'select') {
		return;
	}

	const selectedIndex = target.selectedIndex;
	const selectedValue = target.options[selectedIndex].value;

	if (selectedValue != '') {
		window.location.href = selectedValue;
	}
}
